/** Media types available for recommended content (audio or video) */
export enum ReccoMediaType {
  Audio = 'audio',
  Video = 'video',
}